import { WebApiService } from '../../plugins/webApiService'
import { Events } from '../../plugins/events'
import EventToAsyncDecorator from '../../plugins/eventToAsyncDecorator'
import WsResponseModelT from '../../SchemaBuilderServer/Models/WsResponseModelT';

export default class WsStateWsController {
	webApiService: WebApiService;
	PingEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('WsStateWsController', 'Ping', (res: WsResponseModelT<Boolean>) => {
			self.PingEvent.trigger(res);
		});
	}
	Ping() { 	
        this.webApiService.send('WsStateWsController', 'Ping' );
    }
	 // async methods
	async pingAsync(): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Ping.bind(this), this.PingEvent)();
	}
}